import _ from 'lodash';

export function getGroupName(groupName, metaData, layout, featureName) {
  let name = null;
  if (!metaData)
    return groupName + ' *';

  layout = layout || '';
  switch (groupName) {
    case 'EX L':
      name = __exL(metaData, layout);
      break;
    case 'EX R':
      name = __exR(metaData, layout);
      break;
    case 'Pony Wall':
      name = __ponyWall(metaData, layout);
      break;
    case 'VanityAccent':
      name = __vanityAccent(metaData, layout);
      break;
    case 'Shower Wall Accent':
      name = __showerWallAccent(metaData, layout);
      break;
    case 'ShowerFloor':
      name = __showerFloor(metaData, layout);
      break;
    case 'ShowerPan':
      name = __showerPan(metaData, layout);
      break;
    case 'Shower Wall':
      name = __showerWall(metaData, layout);
      break;
    case 'VanityBacksplash':
      name = __vanityBackSplash(metaData, layout);
      break;
    case 'Wall A':
      name = 'Left Wall';
      break;
    case 'Wall B':
      name = 'Front Wall';
      break;
    case 'Wall C':
      name = 'Right Wall';
      break;
    case 'Floor':
      name = 'Floor';
      break;
    case 'Vanity Handle':
      name = __vanityHandle(metaData);
      break;
    case 'Countertop':
      name = __counterTop(metaData);
      break;
    case 'Shower Door Handle':
      name = __showerDoorHandle(metaData);
      break;
    case 'Backsplash':
      name = __backSplash(metaData);
      break;
  }

  return name || featureName || groupName || '--- NA ---'
}

function __backSplash(metaData) {

}

function __showerDoorHandle(metaData) {
  const ar = [];
  ar.push(__get(metaData['shower']));
  ar.push(__get(metaData['ex L']));
  ar.push(__get(metaData['showerDoor']));
  ar.push(__get(metaData['showerSize']));
  ar.push(__get(metaData['showerPan']));

  return _.filter(ar, _ => !!_).join(', ');
}

function __vanityHandle(metaData) {
  const vanitySize = metaData['vanitySize'];
  if (vanitySize) {
    return `Vanity ${vanitySize}`;
  }

  return null;
}

function __vanityBackSplash(metaData) {
  const countertopSize = metaData['countertopSize'];
  if (countertopSize) {
    return `Vanity Backsplash ${__get(countertopSize)}`;
  }

  return null;
}

function __counterTop(metaData) {
  const counterTopSize = metaData['countertopSize'];
  if (counterTopSize) {
    return `CounterTop ${__get(counterTopSize)}`;
  }

  return null;
}

function __showerWall(metaData) {
  const showerSize = metaData['showerSize'];
  const part = metaData['part'];
  if (showerSize && part) {
    switch (__get(part)) {
      case '1':
        return `Left Shower Wall ${__get(showerSize)} Shower`;
      case '2':
        return `Right Shower Wall ${__get(showerSize)} Shower`;
    }
  }

  return null;
}

function __showerPan(metaData) {
  const showerSize = metaData['showerSize'];
  const exL = metaData['ex L'];
  if (showerSize && exL) {
    switch (__get(exL)) {
      case 'Half':
        return `Half Wall Shower Pan ${__get(showerSize)} Shower`;
      default:
        return `Full Wall Shower Pan ${__get(showerSize)} Shower`;
    }
  }

  return null;
}

function __showerFloor(metaData) {
  const showerSize = metaData['showerSize'];
  if (showerSize) {
    return `Shower Floor ${__get(showerSize)}`;
  }

  return null;
}

function __showerWallAccent(metaData) {
  const showerSize = metaData['showerSize'];
  const part = metaData['part'];
  if (showerSize && part) {
    switch (__get(part)) {
      case '1':
        return `Left Shower Wall Accent ${__get(showerSize)} Shower`;
      case '2':
        return `Right Shower Wall Accent ${__get(showerSize)} Shower`;
    }
  }

  return null;
}

function __vanityAccent(metaData) {
  const countertopSize = metaData['countertopSize'];
  if (countertopSize) {
    return `Vanity Accent ${__get(countertopSize)}`;
  }

  return null;
}

function __ponyWall(metaData) {
  const size = metaData['size'];
  if (size) {
    const value = __get(size);
    switch (value) {
      case '30in':
      case '60in':
        return `SM Room Pony Wall ${value} Shower`;
      default:
        return 'LG Room Pony Wall';
    }
  }

  return null;
}

function __exR(metaData) {
  const countertopSize = metaData['countertopSize'];
  if (countertopSize) {
    if (__has(countertopSize, '72in'))
      return 'SM Room Left Popout Wall 72in Vanity';
    return 'SM Room Left Popout Wall 24-60in Vanity';
  }

  const showerSize = metaData['showerSize'];
  if (showerSize) {
    return `LG Room Right Popout Wall ${__get(showerSize)} Shower`;
  }

  return null;
}

function __exL(metaData) {
  const countertopSize = metaData['countertopSize'];
  if (countertopSize) {
    if (__has(countertopSize, '72in'))
      return 'LG Room Full Left Popout Wall';
    return 'LG Room Half Left Popout Wall';
  }

  const width = metaData['width'];
  const shower = metaData['shower'];
  if (width && shower) {
    let name = '';
    switch (__get(width)) {
      case 'Thick':
        name = 'Full';
        break;
      case 'Half':
        name = 'Half';
        break;
    }
    return `SM Room ${name} Right Popout Wall ${__get(shower)} Shower`;
  }

  return null;
}

function __has(obj, value) {
  return Array.isArray(obj) ? obj.includes(value) : obj === value;
}

function __get(obj) {
  if (!obj)
    return null;
  if (Array.isArray(obj))
    return obj.join(',');
  return obj;
}
